var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useNavigateKeepSession } from "../../tools/useNavigateKeepSession";
import { ETeam, ETurn } from "cresus-common";
import ChargesNotebookComponent from "../../components/player_game_element_component/ChargesNotebookComponent";
import SetOfButtonsPlayerComponent from "../../components/player_game_element_component/SetOfButtonsPlayerComponent";
import MoneyAndPleasureInfoComponent from "../../components/player_game_element_component/MoneyAndPleausreInfoComponent";
import MyTeamDisplayComponent from "../../components/player_game_element_component/MyTeamDisplayComponent";
import ProjectProposalsComponent from "../../components/player_game_element_component/ProjectProposalsComponent";
import ChatComponent from "../../components/ChatComponent";
import useSessionContext from "../../tools/useSessionContext";
import useMedia from "../../contexts/useMedia";
const defaultPlayerDTO = {
    avatarComposition: {
        bonus: 0,
        eyes: 0,
        hair: 0,
        hair_color: 0,
        mouth: 0,
        nose: 0,
        skin: 0,
        teamColor: ETeam.NONE,
    },
    name: "",
    capitain: false,
    team: ETeam.NONE,
    micOn: false,
    sessionPeerId: "undefined",
    isConnected: true,
};
function PlayerDistributionProjectPage() {
    const navigate = useNavigateKeepSession();
    const { sendRequest, websocketPeer, gameState } = useSessionContext();
    const { setCameraMode } = useMedia();
    const [insideGameState, setInsideGameState] = useState(gameState);
    const [myPlayer, setMyPlayer] = useState(defaultPlayerDTO);
    const [isChargesShown, setIsChargesShown] = useState(false);
    const [isChatShown, setIsChatShown] = useState(false);
    const [isNotebookShown, setIsNotebookShown] = useState(false);
    const [newMessageAlert, setNewMessageAlert] = useState(false);
    // --- LOGIQUE DE STABILITÉ ET INITIALISATION ---
    useEffect(() => {
        let cancelled = false;
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                // 1. D'abord, récupérer l'état global pour avoir les équipes
                const freshState = yield sendRequest("onConnectionOrReaload", {
                    gameState,
                });
                if (cancelled || !freshState)
                    return;
                setInsideGameState(freshState);
                // 2. ENSUITE, récupérer l'identité du joueur
                // On utilise le nom du storage ou on demande au serveur
                const storedName = sessionStorage.getItem("playerName");
                if (storedName) {
                    const joinResult = yield sendRequest("joinAsPlayer", {
                        player: { name: storedName },
                    }).catch(() => undefined);
                    if (!joinResult) {
                        if (!cancelled)
                            navigate("/ReconnectionPage");
                        return;
                    }
                }
                else {
                    navigate("/ReconnectionPage");
                    return;
                }
                const me = yield sendRequest("getMyPlayer", { gameState: freshState });
                if (!cancelled && me) {
                    setMyPlayer(me);
                    sessionStorage.setItem("playerName", me.name);
                }
            }
            catch (error) {
                console.error("Erreur d'initialisation post-navigation", error);
                if (!cancelled)
                    navigate("/ReconnectionPage");
            }
        }))();
        return () => {
            cancelled = true;
        };
        // (async () => {
        //   try {
        //     // 1. Récupération de l'état actuel
        //     const freshState = await sendRequest("onConnectionOrReaload", {
        //       gameState,
        //     });
        //     if (cancelled) return;
        //     const baseState = freshState ?? gameState;
        //     setInsideGameState(baseState);
        //     // 2. Reconnexion automatique (Auto-rejoin)
        //     const storedName = sessionStorage.getItem("playerName");
        //     let stateAfterJoin = baseState;
        //     if (storedName) {
        //       const joinResult = await sendRequest("joinAsPlayer", {
        //         player: { name: storedName } as PlayerDTO,
        //       });
        //       if (joinResult && !cancelled) {
        //         stateAfterJoin = joinResult;
        //         setInsideGameState(joinResult);
        //       }
        //     }
        //     // 3. Récupération de l'identité du joueur et persistance
        //     const me = await sendRequest("getMyPlayer", {
        //       gameState: stateAfterJoin,
        //     });
        //     if (!cancelled && me) {
        //       setMyPlayer(me);
        //       sessionStorage.setItem("playerName", me.name); // On "verrouille" l'identité
        //     }
        //   } catch (error) {
        //     console.error("Initialization failed:", error);
        //   }
        // })();
        // return () => {
        //   cancelled = true;
        // };
    }, [sendRequest, websocketPeer]); // S'exécute au montage
    // --- GESTION DES NOTIFICATIONS WEBSOCKET (AVEC NETTOYAGE) ---
    useEffect(() => {
        if (!websocketPeer)
            return;
        const onNotification = (notification) => {
            const methodsToUpdate = [
                "distributeIncome",
                "updateGameState",
                "distributePleasurePoints",
                "distributeCharges",
                "proposeProject",
                "validateProject",
                "startTheGameInitialisation",
            ];
            if (methodsToUpdate.includes(notification.method)) {
                setInsideGameState((prev) => (Object.assign(Object.assign({}, prev), notification.data)));
            }
        };
        websocketPeer.on("notification", onNotification);
        return () => {
            if (typeof websocketPeer.off === "function") {
                websocketPeer.off("notification", onNotification);
            }
        };
    }, [websocketPeer]);
    // --- LOGIQUE DE NAVIGATION ---
    useEffect(() => {
        if (insideGameState.gameStarted) {
            navigate("/GameInProgressPage");
        }
    }, [insideGameState.gameStarted, navigate]);
    // --- LOGIQUE MÉTIER ---
    // ... à l'intérieur du composant
    const myTeam = useMemo(() => {
        var _a;
        console.log("Calcul de myTeam..."); // Pour vérifier quand il s'exécute
        return (_a = insideGameState === null || insideGameState === void 0 ? void 0 : insideGameState.teams) === null || _a === void 0 ? void 0 : _a.find((team) => { var _a; return (_a = team.players) === null || _a === void 0 ? void 0 : _a.some((p) => p.name === myPlayer.name); });
    }, [insideGameState, myPlayer.name]); // Ne recalcule que si ces dépendances changent
    useEffect(() => {
        // Affichage auto du carnet si les charges sont distribuées
        if ((myTeam === null || myTeam === void 0 ? void 0 : myTeam.charges) && myTeam.charges.length > 0) {
            setCameraMode(true, !isNotebookShown, isChatShown);
            setIsNotebookShown(true);
            // setIsChargesShown(true);
        }
    }, [myTeam === null || myTeam === void 0 ? void 0 : myTeam.charges]);
    const checkIfProjectSelected = (team) => !!(team === null || team === void 0 ? void 0 : team.project);
    const handleClickToShowNotebook = () => {
        setCameraMode(true, !isNotebookShown, isChatShown);
        setIsNotebookShown(!isNotebookShown);
    };
    // Force l'activation de la caméra au chargement de la page
    useEffect(() => {
        // Mode caméra actif, carnet fermé, chat fermé par défaut
        setCameraMode(true, false, false);
    }, [setCameraMode]);
    const handleToggleChat = () => {
        setIsChatShown(!isChatShown);
        if (!isChatShown)
            setNewMessageAlert(false);
    };
    return (_jsxs("div", Object.assign({ className: "flex fixed flex-col justify-center items-center h-screen w-screen p-[50px_40px_0_40px]" }, { children: [_jsx(SetOfButtonsPlayerComponent, { alertNewMessage: newMessageAlert, toggleChat: handleToggleChat, isMapModifiable: true, isOnlyConfigButton: false }), myPlayer.name && (_jsx(ChatComponent, { newMessageAlert: setNewMessageAlert, myPlayer: myPlayer, isChatShown: isChatShown, toggleChat: handleToggleChat })), myTeam &&
                myTeam.projectsProposed &&
                myTeam.projectsProposed.length > 0 &&
                !checkIfProjectSelected(myTeam) && (_jsx(ProjectProposalsComponent, { projects: myTeam.projectsProposed })), myTeam &&
                myTeam.incomes &&
                myTeam.charges &&
                myTeam.charges.length > 0 && (_jsx(ChargesNotebookComponent, { isDoubleOn: false, isCaptain: false, cards: [], savings: { amout: 0, percentageOfBonus: 0 }, numberOfMonthPlayed: 0, turnState: ETurn.NO_ACTION_REQUIRED, team: myTeam.teamColor, setInsideGameState: () => { }, incomes: myTeam.incomes, charges: myTeam.charges, project: myTeam.project, isProjectDistributed: checkIfProjectSelected(myTeam), handleCLick: handleClickToShowNotebook })), myTeam && (_jsx(MoneyAndPleasureInfoComponent, { money: myTeam.money, pleasurePoints: myTeam.pleasurePoints })), myPlayer.name && (_jsx(MyTeamDisplayComponent, { myPlayerAvatar: myPlayer.avatarComposition, avatars: myTeam
                    ? myTeam.players
                        .filter((p) => p.name !== myPlayer.name)
                        .map((p) => p.avatarComposition)
                    : [], team: myTeam ? myTeam.teamColor : ETeam.NONE }))] })));
}
export default PlayerDistributionProjectPage;
